import { useMediaQuery } from '@mantine/hooks';
import { useMantineTheme } from '@mantine/core';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

interface ResponsiveLayout {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  deviceType: DeviceType;
  isTouch: boolean;
}

export function useResponsiveLayout(): ResponsiveLayout {
  const theme = useMantineTheme();
  
  // Mantine breakpoints: xs: 36em, sm: 48em, md: 62em, lg: 75em, xl: 88em
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`, true, { getInitialValueInEffect: false });
  const isTablet = useMediaQuery(`(min-width: ${theme.breakpoints.sm}) and (max-width: ${theme.breakpoints.md})`, false, { getInitialValueInEffect: false });
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.md})`, false, { getInitialValueInEffect: false });
  
  // Check for touch capability
  const isTouch = useMediaQuery('(hover: none) and (pointer: coarse)', false, { getInitialValueInEffect: false });
  
  let deviceType: DeviceType = 'desktop';
  if (isMobile) deviceType = 'mobile';
  else if (isTablet) deviceType = 'tablet';
  
  return {
    isMobile,
    isTablet,
    isDesktop,
    deviceType,
    isTouch
  };
}